export const defaultStyle = {
  mainNavWrap:'mainNavWrap relative w-full',
  mainNavInwrap:'mainNavInwrap flex items-center w-full flex lg:max-w-lg xl:max-w-xl xl:w-full lg:px-[15px] items-center lg:mx-auto',
  navContainer: "w-3/4 navContainer w-[75%]",
  mainNavigation:  "mainNavigation flex justify-between ",
  brandLogo:"brandLogo w-[25%] [&>a]:flex [&>a]:max-w-[212px] ",
  topNavButton : "text-[18px]",
  megaNavWrap:" megaNavWrap  z-[99] bottom-[6px] flex  relative  left-[0] w-full bg-purple mt-[-4px]",
  megaNavWrapInwrap:" megaNavWrapInwrap flex absolute left-[0] w-full bg-purple top-[0] overflow-hidden w-full",
  megablandiv:"w-[30%] px-[15px]",
  megadivOne:"megadivOne  pt-[20px] pb-[20px] border-r-[1px] border-[#724d8d] w-[19%] ",
  megadivOneIN:" megadivOneIN cursor-pointer [&:nth-last-child(1)]:pb-[20px]  list-type-none [&>a]:px-[25px] [&>a]:py-[5px] [&>a]:w-full [&>a]:flex [&>a]:text-[18px] [&>a]:text-white [&>a]:tracking-[0.45px]  [&>a]:font-Regular [&>a]:hover:text-oranage400 [&>a]:hover:underline ",
  megadivTwo:"megadivTwo  pb-[20px] pt-[20px]  w-[19%]",
  megadivTwoIN:"megadivTwoIN  relative cursor-pointer [&:nth-last-child(1)]:pb-[20px] list-type-none [&>a]:px-[25px] [&>a]:py-[5px] [&>a]:w-full [&>a]:flex [&>a]:text-[18px] [&>a]:text-white [&>a]:tracking-[0.45px]  [&>a]:font-Regular [&>a]:hover:text-oranage400 [&>a]:hover:underline ",
  ThirdLevelMain:"ThirdLevelMain"
}


